import React from 'react';

import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import {
  useShareClipboard,
  useShareItem,
} from 'components/Share/helpers/hooks';

import { useShareSlideGroupModalStyles } from 'components/Modals/ShareSlideGroupModal/styles';

export const ShareSlideGroupModal = ({ onClose, slideGroup }) => {
  const { uuid, name, share_enabled } = slideGroup;

  const { classes } = useShareSlideGroupModalStyles();

  const { isAllowed, toggleShareHandler } = useShareItem({
    uuid,
    share_enabled,
    itemName: 'Group',
  });

  const handleCopy = useShareClipboard(slideGroup, 'Group');

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open
      onClose={onClose}
    >
      <Box className={classes.modalPaper}>
        <Box className={classes.modalHeader}>
          <Typography className={classes.title}>Share {name} Group</Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            className={classes.closeIcon}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={classes.modalContent}>
          <Box className={classes.buttonsContent}>
            <Button
              variant="contained"
              color={isAllowed ? 'primary' : 'default'}
              fullWidth
              onClick={toggleShareHandler}
              className={classes.shareButton}
            >
              Share Group: {isAllowed ? 'On' : 'Off'}
            </Button>
            <Button
              variant="contained"
              fullWidth
              disabled={!isAllowed}
              onClick={handleCopy}
              className={classes.copyButton}
            >
              <ContentCopyIcon />
              Copy Link
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
